import { ref } from "vue";
import { useRequestsStore } from "@/stores/storeRequests";
import { useSettingsStore } from "@/stores/storeSettings";
import { useFieldsStore } from "@/stores/storeFieldData";
import { sendMetrik, trackPixel } from "@/utils/metrika";

const pushEvent = () => {};
const smartPixel = () => {};
const trackAdriver = () => {};

let modalsInstance;

export const useModals = () => {
	if (modalsInstance) {
		return modalsInstance;
	}

	const activeModal = ref(false);
	const modalId = ref(null);
	const modalContent = ref(null);
	const sizeWidthModal = ref('')

	const storeRequests = useRequestsStore();
	const storeSettings = useSettingsStore();
	const storeField = useFieldsStore();

	const disableScroll = () => {
		lockPadding();
		document.body.classList.add("noscroll");
	};

	const enableScroll = () => {
		document.body.classList.remove("noscroll");
		unlockPadding();
	};

	const lockPadding = () => {
		const paddingOffset = `${window.innerWidth - document.body.offsetWidth}px`;
		document.body.style.paddingRight = paddingOffset;
	};

	const unlockPadding = () => {
		document.body.style.paddingRight = "0px";
	};

	const closeRegistration = () => {
		if (modalId.value === "registration" && modalId.value !== "registrationEnd" && !storeRequests.isRegistrationSuccess) {
			sendMetrik("reachGoal", "signup_leave");
			pushEvent("registr-closed")
			storeField.updateRegestrationBtn();
		}
		storeRequests.isRegistrationSuccess = false;
	};

	const closeModal = () => {
		activeModal.value = false;
		closeRegistration();
		if (modalId.value === "authorization") {
			storeField.updateBtnsTitles(["email", "password"]);
		}
		modalId.value = null;
		enableScroll();
		storeRequests.responseError = "";
		if (storeRequests.isAuthenticated) {
			storeField.fields.email.disabledBtn = true;
		}
	};
	
	const openModal = (id, options = {}) => {
		const { content = null, size = ''} = options; /* { content: user, size: '600' } { content: user } { size: '500' }. В модалке modalContent.key */
		closeModal();
		disableScroll();
		activeModal.value = true;
		modalId.value = id;
		// modalContent.value = content;
		if ('content' in options) {
			modalContent.value = options.content;
		}
		sizeWidthModal.value = size;
	};

	const triggerQrScan = (type) => {
		const qrElement = document.getElementById("apm-scan-qr");
		// sendMetrik("reachGoal", "Check_Click");
		smartPixel('click_download_receipt');

		switch(type) {
			case 'upload_check':
				sendMetrik('reachGoal', 'upload_check'); //Клик по кнопке «загрузить чек», первый экран
				trackPixel('CONVERSION', 'upload_check')
				trackAdriver('participate')
				break;
			case 'upload_check_mechanics':
				sendMetrik('reachGoal', 'upload_check_mechanics'); //«участвовать», первый экран
				trackPixel('VIEW', 'participation')
				trackAdriver('participate')
				break;
			case 'upload_check_lk':
				sendMetrik('reachGoal', 'upload_check_lk'); //«загрузить чек», ЛК первый экран
				trackPixel('CONVERSION', 'upload_check')
				trackAdriver('upload-receipt-lc')
				break;
			case 'upload_check_3_in_a_row_lk':
				sendMetrik('reachGoal', 'upload_check_3_in_a_row_lk'); // «загрузить чек», ЛК игра «3 в ряд»
				trackPixel('CONVERSION', 'upload_check')
				trackAdriver('upload-receipt-lc')
				break;
			case 'click_leaf_fall_lk':
				sendMetrik('reachGoal', 'click_leaf_fall_lk'); // «загрузить чек», ЛК игра «Листопад»
				trackPixel('CONVERSION', 'upload_check')
				trackAdriver('upload-receipt-lc')
				break;
			case 'upload_check_winners':
				sendMetrik('reachGoal', 'upload_check_winners'); // «Клик по кнопке «участвовать», победители
				trackAdriver('participate')
				break;
			case 'upload_check_last_lk':
				sendMetrik('reachGoal', 'upload_check_last_lk'); // Клик по кнопке «загрузить чек», ЛК последний экран
				break;
			case 'game_3_in_a_row_lk_2':
				sendMetrik('reachGoal', 'game_3_in_a_row_lk_2'); // «Клик по кнопке «загрузить чек», ЛК игра «3 в ряд» после игры
				trackAdriver('upload-receipt-lc')
				break;
			case 'upload_check_3_popup':
				sendMetrik('reachGoal', 'upload_check_3_popup'); // «Клик по кнопке «загрузить чек», ЛК игра «3 в ряд» после игры
				trackAdriver('upload-receipt-lc')
				break;
			case 'upload_check_leaf_fall_lk':
				sendMetrik('reachGoal', 'upload_check_leaf_fall_lk'); // «Клик по кнопке «загрузить чек», ЛК игра листопад
				
				break;
			case 'upload':
				trackPixel('CONVERSION', 'upload_check')
		}
			
		
		setTimeout(() => {
			const closeApmBtn = document.getElementById("apm-close-widget-button");
			closeApmBtn?.addEventListener("click", () => {
				sendMetrik('reachGoal', 'check_leave');
				pushEvent('receipt-upload-closed')
				smartPixel('download_receipt_cancel');
			});
		}, 1000);
		if (storeSettings.statusStockFuture) {
			openModal("promoNotStart");
		}
		if (storeSettings.statusStockPast) {
			openModal("promoEnd");
		}
		if (qrElement && storeRequests.isAuthenticated && storeSettings.statusStockActive) {
			qrElement.click();
			
			
			// if(storeRequests.userData?.receipt_status === 'upload_available') {
			//     qrElement.click();
			// } else {
			//     openModal('downloadReceiptsEnd');
			// }

			
			
		}
		if (!storeRequests.isAuthenticated && storeSettings.statusStockActive) {
			openModal("authorizationRequired");
		}
	};

	const modalInfo = [
		{
			id: 0,
			title: '',
			text: `
				<p>Каждый рубль, потраченный на любой чай Greenfield, превращается в листочек.</p>
				<p>Обменивайте их на призы или билеты для участия в еженедельном и главном розыгрышах.</p>			
			`,
			leaf: `
			<div class="count-info">
				<span class="white">1 рубль</span> =
				<span class="yellow">
					1 <svg width="24" height="24"><use href="#leaf"></use></svg>
				</span>
			</div>
			`
		},
		{
			id: 1,
			title: 'Розыгрыш главного приза',
			text: `
				<p>В&nbsp;розыгрыше участвуют все билеты, купленные за&nbsp;весь период акции.</p>		
				<p>Каждый билет&nbsp;&mdash; отдельная заявка.
				Победитель будет определён 22&nbsp;декабря 2026 года
				(подробности&nbsp;&mdash; в&nbsp;правилах акции).</p><br>			
				<p>Каждый дополнительный билет увеличивает шанс на&nbsp;победу.Покупка билета не&nbsp;гарантирует выигрыш.</p><br>			
				<p>Результаты розыгрышей публикуются на&nbsp;сайте акции.</p>			
			`,
			leaf: `
			`
		},
	]

	return (modalsInstance = { activeModal, modalId, modalContent, sizeWidthModal, modalInfo, closeModal, openModal, triggerQrScan });
};
